export default __webpack_public_path__ + "9ba993a0d58d2b20801ed88137b6f95d.png";